import axiosInstance from '../../../api/AxiosInstance';
import { endpoints } from '../../../services/endpoints';
import { addUnitsRequest, addUnitsRequestError, addUnitsRequestSuccess } from '../../slices/Content/AddUnitSlice';

export const AddUnitsAPI = (data) => {
    return async (dispatch) => {
        try {
            dispatch(addUnitsRequest());
            // Returning the promise so we can await it in handleSubmit
            const response = await axiosInstance({
                method: "POST",
                url: endpoints.addUnitsContent,
                data: data,
            })
            return dispatch(addUnitsRequestSuccess(response?.data));
        } catch (error) {
            const _error = {
                data: error?.response?.data?.message || error?.message,
                status: error?.response?.status || error?.status,
            };
            return dispatch(addUnitsRequestError(_error));
        }
    };
};
